import React, { useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import ProductZoom from "../../components/ProductZoom";
import { useBlockPropertyMutation } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";
import moment from "moment/moment";

const PropertyDetails = ({ details, getView }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [modal, setModal] = useState(false);

  // RTK QUERY
  const [blockPropertyApi] = useBlockPropertyMutation();

  const [full_from_date, setfull_from_date] = useState("");
  const [full_to_date, setfull_to_date] = useState("");

  const [full_from_dateErr, setfull_from_dateErr] = useState(false);
  const [full_to_dateErr, setfull_to_dateErr] = useState(false);
  const [btn, setBtn] = useState(false);

  const blockProperty = () => {
    if (full_from_date?.length == 0 || full_to_date?.length == 0) {
      setfull_from_dateErr(true);
      setfull_to_dateErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("from_date", moment(full_from_date).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(full_to_date).format("YYYY-MM-DD"));
      formdata.append("property_id", location?.state?.data?.id);
      setBtn(true);
      dispatch(saveLoader(true));
      blockPropertyApi(formdata)
        .unwrap()
        .then((res) => {
          setBtn(false);
          dispatch(saveLoader(false));
          if (res?.status == "success") {
            onClose(false);
            Swal.fire({
              text: res?.message,
              icon: "success",
            });
            getView();
          }
        })
        .catch((err) => {
          console.log("err", err);
          setBtn(false);
          dispatch(saveLoader(false));
        });
    }
  };

  const onClose = () => {
    setfull_from_date("");
    setfull_to_date("");
    setfull_from_dateErr(false);
    setfull_to_dateErr(false);
    setModal(false);
  };

  return (
    <div>
      {" "}
      <div className="user-detail-table">
        <table className="tabledetails table-borderless user-det w-100 mb-5">
          <thead>
            <th colspan="3" className="h8 mb-0 font-weight-light p-3">
              BASIC DETAILS
            </th>
          </thead>
          <tbody>
            <tr>
              <td style={{ width: "40%" }}>
                <button
                  className="btn btn-secondary"
                  onClick={() => setModal(true)}
                >
                  Property Block
                </button>
              </td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Property Id</td>
              <td>:</td>
              <td>{details?.property?.property_id}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Property Owner Name</td>
              <td>:</td>
              <td>{details?.property?.owner?.name}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Hotel Category</td>
              <td>:</td>
              <td>{details?.property?.category?.name}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Category Services</td>
              <td>:</td>

              <td>
                {details?.services?.map((item, ind) => {
                  return (
                    <div className="d-flex flex-column mb-3" key={ind}>
                      {item == "room_booking"
                        ? "Room Booking"
                        : item == "get_together"
                        ? "Get Together"
                        : item == "room_sharing"
                        ? "Room Sharing"
                        : item == "day_outing"
                        ? "Team Outing"
                        : item == "just_walking"
                        ? "Just Walking"
                        : ""}
                    </div>
                  );
                })}
              </td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Property Name</td>
              <td>:</td>
              <td>{details?.property?.name}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Property Image</td>
              <td>:</td>
              <td>
                <img
                  src={details?.property?.image}
                  alt="property-img"
                  class="img-fluid"
                  style={{ width: "30%" }}
                />
              </td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>State</td>
              <td>:</td>
              <td>{details?.property?.state?.name}</td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>City</td>
              <td>:</td>
              <td>{details?.property?.city?.name}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Area</td>
              <td>:</td>
              <td>{details?.property?.location?.name}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Street</td>
              <td>:</td>
              <td>{details?.property?.street}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Appartment</td>
              <td>:</td>
              <td>{details?.property?.apartment}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Block</td>
              <td>:</td>
              <td>{details?.property?.block}</td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Door No</td>
              <td>:</td>
              <td>{details?.property?.door_no}</td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Pincode</td>
              <td>:</td>
              <td>{details?.property?.pincode}</td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Landmark</td>
              <td>:</td>
              <td>{details?.property?.landmark}</td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Latitude</td>
              <td>:</td>
              <td>{details?.property?.latitude}</td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Longitude</td>
              <td>:</td>
              <td>{details?.property?.longitude}</td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Pincode</td>
              <td>:</td>
              <td>{details?.property?.pincode}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Status</td>
              <td>:</td>
              <td
                className={`${
                  details?.property?.status == 1
                    ? "text-success"
                    : "text-danger"
                }`}
              >
                {details?.property?.status == 1 ? "Active" : "De Active"}
              </td>
            </tr>

            <tr>
              <td style={{ width: "40%" }}>Amenities</td>
              <td>:</td>
              <td className="amenity-type">
                <ul>
                  {details?.property?.amenities?.map((item, ind) => {
                    return (
                      <li key={ind}>
                        <img src={item?.image} />
                        {item?.name}
                      </li>
                    );
                  })}
                </ul>
              </td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Description</td>
              <td>:</td>
              <td>{details?.property?.decscription}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Short Notes</td>
              <td>:</td>
              <td>{details?.property?.short_notes}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Policy Rules</td>
              <td>:</td>
              <td>{details?.property?.policy_rules}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Couple Friendly</td>
              <td>:</td>
              <td>{details?.property?.couple_friendly ? "Yes" : "No"}</td>
            </tr>
            <tr>
              <td style={{ width: "40%" }}>Get-To-Gether</td>
              <td>:</td>
              <td>{details?.property?.family_friendly ? "Yes" : "No"}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <h2 class="content-heading">
        Property{" "}
        <small>
          <code class="text-lowercase">Images</code>
        </small>
      </h2>
      <div className="d-flex gap-3 mb-5">
        <div className="col-md-4 mx-3">
          {details?.property?.images?.map((item, ind) => {
            return (
              <div key={ind} className={"mt-2"}>
                <ProductZoom image_url={item?.image} />
              </div>
            );
          })}
        </div>
      </div> */}
      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                Block Room
              </label>
              <button className="cust-btn" onClick={() => onClose(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="mt-4">
            <div className="col-md-12 mb-4">
              <label className="f1 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                From Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={full_from_date}
                  onChange={(date) => {
                    setfull_from_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={moment().toDate()}
                />
              </div>
              {full_from_date?.length == 0 && full_from_dateErr && (
                <p className="err">Select From Date</p>
              )}
            </div>

            <div className="col-md-12">
              <label className="f1 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                To Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={full_to_date}
                  onChange={(date) => {
                    setfull_to_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={moment().toDate()}
                />
              </div>
              {full_to_date?.length == 0 && full_to_dateErr && (
                <p className="err">Select To Date</p>
              )}
            </div>
          </Row>
          <Row className="mt-4 d-flex ac-jc">
            <div className="col-md-2 text-center">
              <button
                className={`submit-btn ${btn ? "opacity-50" : ""}`}
                onClick={() => blockProperty()}
                disabled={btn}
              >
                OK
              </button>
            </div>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default PropertyDetails;
